<ng-container>
  <ng-container [ngSwitch]="field">
    <ng-container *ngSwitchCase="'PRICE'">
      <orderform-product-price
        class="force-style"
        *ngIf="product$ | async as product; else productNotFound"
        [product]="product"
        display="unit_amounts"
      ></orderform-product-price>
    </ng-container>
    <ng-container *ngSwitchCase="'INPUT'">
      <ng-container [formGroup]="form" *ngIf="form">
        <orderform-quantity-input
          (click)="$event.stopPropagation()"
          class="force-style"
          *ngIf="product$ | async as product; else productNotFound"
          formControlName="quantity"
          [product]="product"
          [mainProduct]="mainProduct$ | async"
          [showQuantitySelectLabel]="false"
        ></orderform-quantity-input>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <img
        alt="Arrow image"
        class="arrow"
        [src]="imageUrl$ | async"
        *ngIf="imageUrl$ | async; else productNotFound"
    /></ng-container>
  </ng-container>
</ng-container>

<ng-template #productNotFound>
  {{ field }}
</ng-template>
